import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#059669]" />
      </div>
    );
  if (user === false) return <Navigate to={loc.pathname.startsWith("/dashboard") ? "/login?role=adviser" : "/login"} state={{ from: loc.pathname }} replace />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={user.role === "user" ? "/dashboard" : "/admin"} replace />;
  }
  return children;
}
